import { render } from "./StatisticTurnoverSummary.vue?vue&type=template&id=2976b89c&ts=true"
import script from "./StatisticTurnoverSummary.vue?vue&type=script&lang=ts"
export * from "./StatisticTurnoverSummary.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__